import React from 'react';
import './CardTest.css';
import Card from './Card';

function CardTest() {
  const testCards = [
    { suit: 'hearts', value: 'A' },
    { suit: 'diamonds', value: 'K' },
    { suit: 'clubs', value: 'Q' },
    { suit: 'spades', value: 'J' },
  ];

  return (
    <div className="card-test-container">
      <div className="card-test-header">
        <h1>Card Design Test</h1>
        <p>Preview of all 4 standard suits</p>
      </div>

      <div className="card-section">
        <h2>&#9829; Hearts (Red)</h2>
        <Card card={{ suit: 'hearts', value: 'A' }} />
        <Card card={{ suit: 'hearts', value: '7' }} />
        <Card card={{ suit: 'hearts', value: '3' }} />
      </div>

      <div className="card-section">
        <h2>&#9830; Diamonds (Red)</h2>
        <Card card={{ suit: 'diamonds', value: 'K' }} />
        <Card card={{ suit: 'diamonds', value: '9' }} />
        <Card card={{ suit: 'diamonds', value: '5' }} />
      </div>

      <div className="card-section">
        <h2>&#9827; Clubs (Black)</h2>
        <Card card={{ suit: 'clubs', value: 'Q' }} />
        <Card card={{ suit: 'clubs', value: '8' }} />
        <Card card={{ suit: 'clubs', value: '2' }} />
      </div>

      <div className="card-section">
        <h2>♠ Spades (Black)</h2>
        <Card card={{ suit: 'spades', value: 'J' }} />
        <Card card={{ suit: 'spades', value: '10' }} />
        <Card card={{ suit: 'spades', value: '4' }} />
      </div>

      <div className="card-section">
        <h2>Card Back</h2>
        <Card card={{ suit: 'hearts', value: 'A' }} faceDown />
        <Card card={{ suit: 'diamonds', value: 'K' }} faceDown />
        <Card card={{ suit: 'clubs', value: 'Q' }} faceDown />
      </div>
    </div>
  );
}

export default CardTest;
